// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__14gMX","loaderOuter":"PageOverlayLoader_loaderOuter__3cziR"};